 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		101: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"components-video_module-video_module","4":"ibdPage","6":"legacyIbdPage","8":"ad-AdContainer","9":"components-analytics-analytics","10":"components-feature_feed-feature_feed","11":"container","12":"fc_executive_board","13":"fc_link-fc_link","14":"post-content-body","15":"aboutUsWpPage","16":"author","17":"category_page","18":"components-not_found_component-not_found_component","19":"components-slug-slug","20":"customCollectionPage","21":"feed","22":"list_page","23":"list_page_2024","24":"list_page_2025","25":"loginPage","26":"logoutPage","27":"magazineTagPage","28":"magazine_page","29":"myAccountPage","30":"newsletters_page_marketo","31":"notFoundPage","32":"offerPage","33":"playlistIndexPage","34":"playlistPage","35":"podcastPage","36":"post_page","37":"registerPage","38":"resetPasswordPage","39":"sitemapIndex","40":"sitemapPost","41":"splash_page","42":"splash_page_new","43":"stories","44":"subscribePage","45":"tagPage","46":"videoIndex","47":"videoPage","48":"views-containers-layouts-blank_layout-blank_layout","49":"views-containers-layouts-web_layout-web_layout","96":"MarketoNewsletterForm","97":"MicCarousel","98":"MicIcon","99":"MicMobileIconCarousel","100":"Success-SubmissionSuccess","102":"applications-most-innovative-companies","103":"brands_that_matter_2021","104":"brands_that_matter_page","105":"categoryLink","106":"components-ApplyPageImportantDates-ApplyPageImportantDates","107":"components-BackgroundHighlight-BackgroundHighlight","108":"components-BtmCmos-index","109":"components-BtmPastHonereesLogos-index","110":"components-MultiTabList-MultiTabList","111":"components-QuickCarousel-QuickCarousel","112":"components-StickyBar-StickyBar","113":"components-all_feed-all_feed","114":"components-categories","115":"components-config-config","116":"components-editor_highlights-editor_highlights","117":"components-finite_scroll","118":"components-footer-footer","119":"components-franchise_intro-franchise_intro","120":"components-ibd_category-ibd_category","121":"components-image-image","122":"components-magazine_archive-magazine_archive","123":"components-masthead-masthead","124":"components-mcp_section-mcp_section","125":"components-mic_card-mic_card","126":"components-mic_mobile_menu-mic_mobile_menu","127":"components-more-stories-component-more-stories-component","128":"components-newsletters-recaptcha","129":"components-notice","130":"components-podcast_tile-podcast_tile","131":"components-podcast_tile-podcast_tile_featured","132":"components-post-content-insert","133":"components-ranked","134":"components-recirc-recirc","135":"components-related_posts-related_posts","136":"components-related_slider-related_slider","137":"components-sectors_list-sectors_list","138":"components-social-social","139":"components-top_50-top_50","140":"components-top_50_shuffle-top_50_shuffle","141":"components-video_megatron-video_megatron","142":"containers-pages-list_landers-bwi-2020","143":"containers-pages-list_landers-ibd-2020","144":"containers-pages-list_landers-mic-2021","145":"content-innovation_festival_banner","146":"content-sponsor_bar","147":"fc-components-main-components","148":"fc-components-main-components-StickyBar-StickyBar","149":"fc-components-main-containers","150":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","151":"fc-components-main-containers-IbdLayout-IbdLayout","152":"fc-components-main-containers-MicLayout-MicLayout","153":"fc-components-main-containers-WciLayout-WciLayout","154":"fc-components-main-utils-ConditionalWrapper","155":"franchises-BtmApplyPage","156":"franchises-BwiApplyPage","157":"franchises-IbdApplyPage","158":"franchises-MicApplyPage","159":"franchises-NbttApplyPage","160":"franchises-WciApplyPage","161":"innovation_by_design_future_page","162":"innovation_by_design_page_franchise","163":"innovation_by_design_page_franchise_2023","164":"layouts","165":"layouts-mcp","166":"nav_main_menu-nav_main_menu","167":"package_article_list_entry","168":"packages-nav-package_sticky_nav","169":"post-content-sidebar","170":"topics"}[chunkId]||chunkId) + "." + {"1":"821943b4b0947685b818","2":"c329fcd62a3edf7e4a63","3":"004ec6913043882e6b4c","4":"6ade2b8a11922076dd3d","5":"57d9ce3c49278f4f70e7","6":"f148e01028b30c574025","7":"f6ea3f9b7eb5fa720e72","8":"db98f07af373c010b176","9":"dc9244f01823ef83c6c4","10":"131fcc72d17cb56c9122","11":"e728bcaade22e20bc042","12":"059662fe89b6e2cd942c","13":"bc770d9ad32432e0c19c","14":"530c244e5ce98163ebdb","15":"ac5fa152f4104acd8617","16":"6f5dffbb38c551f6b356","17":"ba0bf85d08ebefc6d72d","18":"aef52050efc33753bf74","19":"bc2a03cf8548271a2788","20":"250f8fe84dc53337d108","21":"9ecc307c80ab6aa1f674","22":"2656e8cbcec85b8722bd","23":"df3419196155736ef492","24":"09e29fa317b13c1e6895","25":"8caded76ec73d2f83441","26":"cac4d2e8b54d8b6807db","27":"11070265fef59bc24203","28":"b4cf66ea3a224de160d0","29":"28acd65d87bfcae674ec","30":"c4685a630f8ab6105d27","31":"be969e627ac509e7591e","32":"bcb5ce46103c4adae7a6","33":"d8f877ed5f5980fe4ec2","34":"58bb04c90e381ab91081","35":"3996a9f9955224e158f0","36":"3ae49f03439afae4a908","37":"69e4a5c3f192378ef8af","38":"7577df7fed0e18536046","39":"8d9a6244cc77f4ae3fb3","40":"7836e9c65cc710955fc9","41":"4154d32762b39fcf6a6c","42":"ea517af127965ef80cc9","43":"022b8ccdc2150db7c465","44":"078dacc10e4d01fef766","45":"52d50a05cc8e3ca05649","46":"a20f0217f58263668b87","47":"5e836d28f6ff71bc65df","48":"768086ae7d217998e6e2","49":"a38449c04992fd9688a3","50":"0067838efd0ecd518379","51":"597b6f202d3de87cb0ca","52":"c3ab65fa88c9adef0a73","53":"56c1ae59e64faa88b809","54":"ba970fd7847c84d70f4c","55":"5c29dc215ddac2389d0b","56":"9d868004ae2860d030ec","57":"2df5b29f4c695d6b38c7","58":"c81aaee7b7dae012267d","59":"2e7e9625227a62a8e26c","60":"099b7f77871d727e090b","61":"b4e55f88475fa29169b3","62":"0ee59e6bfded633c33d4","63":"e6581f96b1460fe278a2","64":"ee2090560012db8e8c58","65":"4e66900754cb4781b709","66":"66dacc2d08530e4ac501","67":"0e986d212e7ec5cf9e1d","68":"0c1cc39732e17a35c214","69":"9a2aaa3a48c9f9f89f4d","70":"e4b85985588d0141d2e9","71":"fed9f1f0980ea7b0f8b6","72":"c92c2b76b145d057b326","73":"769886c48848e5b67fbd","74":"cd6ea73bc90f4fb2e64b","75":"4eb167ad047b5173147f","76":"407077051d956985215f","77":"6a3acab29410430d198e","78":"b43cda492e379ad3b60d","79":"7e71296ab937d78250b8","80":"f520a83a7c5a583f1d96","81":"0787dfd338c9d6f43648","82":"2e41b2ed9ae7cabe53c0","83":"4edda411b57cfdc152a7","84":"c07bec4aad150a8de2eb","85":"91423fdeeaba6135af09","86":"eef461dd1ec108c9fb80","87":"5eed2ab5fd6dd1216f26","88":"13bdf3041c3474f0180c","89":"3fa30b454815fe45555e","90":"584c49b4aed5ea4eb5ba","91":"767204901c7d0810f347","92":"7f835127452a7d3f0bf2","93":"8e7349634ea20a445012","94":"5a56e565391eb82d1e41","95":"14ded7f27e327e4b1cce","96":"2df25148e8499c69ea5c","97":"79866d14c98a4565fda1","98":"988fd5d23b5daae0c6f8","99":"2b6f81b493a2d9ec5d45","100":"49099d011a1ad66943eb","102":"2cceb6f35fd5a623aed7","103":"03fd4e9cfeadf560a481","104":"46ca2d8aa63f34cd5465","105":"e77def14bca07f9107e0","106":"033cf675b71d0a8480de","107":"7bc7948d64cf4144d4d3","108":"5c948007939c6243ac8b","109":"d38a15ead363ef078f11","110":"d5cfec2462b8e5bfb5d1","111":"9baa26f9743bcadde291","112":"473b193654b36d5d0328","113":"104a71d672edd9e2930b","114":"775408c82e565b5bd36d","115":"4a10cb81970e5361e11b","116":"93e82be58901b65e975d","117":"da35cbb4f45af3c5dab8","118":"ff3116c30655baab7847","119":"d5c2e4badc3fa5d93acb","120":"58a0273b068e2141e283","121":"6e8fe5bfb6d8ef9bdae6","122":"cc4aac5f878f781e3de7","123":"e8fdf24596760044204d","124":"cc1f952cc1b4630e3a25","125":"155722fa686b93a15f3b","126":"f2682839c52ccc708a20","127":"29b18475af5406a2ba24","128":"2a3b8f3b51790409a987","129":"793ffecbfe0b2e891b11","130":"1af3a512340d752fb0ab","131":"357bedbfceea0e502d17","132":"63ea1a1b7781af607486","133":"2f63165d66faf8a18f12","134":"abf7eda1ef9713f049ec","135":"37f02140c307b4784d27","136":"22b8cac78827683e5774","137":"e53efde07d9c1215b4a5","138":"cf9f3c29b4a4bcbc41a1","139":"3f4e7d5fb0d75e8fe3b4","140":"2637411dc35443400a32","141":"b1b6b90ac1fd8aab4306","142":"6bbd720bd2b4fcb84b20","143":"97566fb5436d16e77506","144":"9a54aaa72a00a15e3bf2","145":"a6939cf70088ed778f76","146":"7cc2c8e5b9642af0807a","147":"e462a6f76ce8be8ef57c","148":"0aa3dcb9706a228069d3","149":"4d86a004365c6583ce9c","150":"bcc8bcce13c1584f50f5","151":"da49bdbb5ed80f1549ab","152":"3503947a665cf4a86f25","153":"b82b946577308d66dd69","154":"a2fe67415aa2bf0bfc14","155":"0aa98c3be22f9fe2a64b","156":"0a9633416d88cc9a7962","157":"6a35a2582a67a53de419","158":"48b5e229cb414f315a1d","159":"c307d06d05e3a4fff2e3","160":"5df2a6885507f6b96eb4","161":"2c1ef8e439b40a4d008a","162":"ad4253dee8bafbc2cc42","163":"7df7451fafb748fa0c94","164":"71a586f77115d83db1d6","165":"fcfd2d0098533d619c2b","166":"04da30e973b704b9cc6e","167":"29597dbfc5e1d128b0d2","168":"491dea7fa6ad1326c314","169":"9a06a54ce5076d1ef509","170":"3e24ff609960ed49dc16"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([764,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
